import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";

export default function PANMain() {
  const navigate = useNavigate();
  const [choice, setChoice] = useState("");

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="mx-auto max-w-3xl">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl">🪪 PAN Form</CardTitle>
            <p className="text-muted-foreground">Select the PAN service you want to continue with.</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="grid gap-4 md:grid-cols-2">
              <button type="button" onClick={() => setChoice("new")} className={`rounded-2xl border p-6 text-left transition ${choice === "new" ? "border-primary bg-primary/10 ring-2 ring-primary" : "hover:bg-muted"}`}>
                <div className="text-xl font-semibold">PAN New</div>
                <p className="mt-2 text-sm text-muted-foreground">Create a new PAN application form.</p>
              </button>
              <button type="button" onClick={() => setChoice("update")} className={`rounded-2xl border p-6 text-left transition ${choice === "update" ? "border-primary bg-primary/10 ring-2 ring-primary" : "hover:bg-muted"}`}>
                <div className="text-xl font-semibold">PAN Update</div>
                <p className="mt-2 text-sm text-muted-foreground">Update or correct an existing PAN record.</p>
              </button>
            </div>
            <div className="flex justify-end">
              <Button type="button" disabled={!choice} onClick={() => navigate(choice === "new" ? "/Fill_My_Form/PAN_FORMS/PANNew" : "/Fill_My_Form/PAN_FORMS/PANUpdate")}>Next →</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
